// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-1ccf3917]:export {\n  theme: #30B08F;\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}\n\n/* Mixins */\n.track_content[data-v-1ccf3917] {\n  background: #fff;\n  padding: 10px;\n}\n.track-card[data-v-1ccf3917] {\n  margin-top: 20px;\n}\n.track-card p[data-v-1ccf3917] {\n  font-size: 16px;\n  line-height: 30px;\n}\n.track-card p span[data-v-1ccf3917] {\n  padding: 16px;\n}", ""]);
// Exports
module.exports = exports;
